module.exports = __webpack_public_path__ + "static/img/wenhua9.9714a72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua9.jpg
// module id = BIug
// module chunks = 1